
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13170',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13170",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.679",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9926",
  "foundations-components": "static-1.8437",
  "foundations-components-legacy": "static-1.1462",
  "foundations-theming": "static-1.4738",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8298",
  "hub-http-shared-msw-handlers": "static-1.10566",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11756",
  "I18n": "static-7.1667",
  "jasmine-runner": "static-1.6721",
  "marketplace-discovery-studio-lib": "static-1.587",
  "marketplace-storefront-base": "static-1.13233",
  "quartz": "static-1.7413",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "reactive-variable-buffer-atom": "static-1.3122",
  "reporting-testing-lib": "static-1.10628",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12790",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7588",
  "ui-addon-i18n": "static-1.11414",
  "ui-addon-react-router-dom": "static-1.9806",
  "unified-auth": "static-1.856",
  "unified-auth-core-lib": "static-1.1138",
  "usage-tracker": "static-1.7624",
  "usage-tracker-core": "static-1.7474",
  "customer-data-property-utils": "static-1.8370",
  "hub-http": "static-1.6481",
  "integrations-lib": "static-1.16975",
  "marketplace-ui-common": "static-1.20657",
  "marketplace-ui-install": "static-1.643",
  "property-management-iframe": "static-1.14063",
  "quartz-config": "static-1.1191",
  "quartz-core": "static-1.6632",
  "quartz-routing": "static-1.843",
  "quick-fetch": "static-1.4109",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4933",
  "ts-schema": "static-1.4271",
  "ui-universal-auth": "static-1.9342",
  "UIComponents": "static-3.8702",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3596",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3690",
  "quartz-webpack": "static-1.3637",
  "bend-plugin-quartz-routing": "static-1.491",
  "ai-components-ui-library": "static-1.9650",
  "codemirror": "static-5.99",
  "foundations-assets": "static-1.5151",
  "pulse": "static-1.896",
  "react-codemirror": "static-1.10907",
  "ui-extensions-preview-lib": "static-1.542",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4706",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2454",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9695",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.66",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5534",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.499",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2547",
  "ui-fonts": "static-1.1018",
  "ui-images": "static-2.1238",
  "bend-plugin-foundations-theming": "static-1.3221",
  "foundations-theming-base": "static-1.3723",
  "stylex": "static-1.38",
  "HeadJS": "static-2.793",
  "hs-test-utils-bend-plugin": "static-1.3409",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4582",
  "ui-addon-video-player": "static-1.8970",
  "ai-rendering-library": "static-1.11045",
  "chirp-fetch": "static-1.2162",
  "connections-embed-lib": "static-1.1471",
  "copilot-toolkit": "static-1.11795",
  "feedback-loader": "static-1.29767",
  "laboratory-lib": "static-3.7420",
  "marketplace-embed": "static-1.22846",
  "marketplace-ui-details": "static-1.10552",
  "marketplace-ui-reviews": "static-1.20612",
  "marketplace-ui-tracking": "static-1.14827",
  "sanitize-text": "static-1.8421",
  "usage-tracker-multi": "static-1.6038",
  "usage-tracker-session-replay": "static-1.5310",
  "wootric-nps": "static-1.7177",
  "quartz-head": "static-1.1078",
  "web-vitals": "static-1.12",
  "apollo-link-hub-http": "static-2.4924",
  "immer": "static-1.94",
  "immerable": "static-1.4419",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2661",
  "reporting-data": "static-1.68695",
  "cssUtils": "static-1.888",
  "flux-actions": "static-1.364",
  "HubStyle": "static-2.12063",
  "PatternValidationJS": "static-1.3163",
  "react-colorpicker": "static-2.10476",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10638",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7614",
  "icons": "static-2.677",
  "marketplace-ui-apps-core": "static-1.19189",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4776",
  "foundations-components-test-utils": "static-1.5920",
  "quartz-i18n": "static-1.1088",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.406",
  "ads-unified-auth-lib": "static-1.1195",
  "google-sheets-integration-lib": "static-1.975",
  "microsoft-drive-auth-lib": "static-1.74",
  "surveymonkey-integration-lib": "static-1.420",
  "slack-ui-library": "static-1.10666",
  "fsm": "static-1.4013",
  "customer-data-objects": "static-1.7955",
  "property-translator": "static-1.5666",
  "hs-locale-management": "static-1.270",
  "frontend-preferences-client": "static-1.8191",
  "hs-promise-utils": "static-1.5865",
  "hubspot-apollo-client": "static-1.5147",
  "integrations-error-boundary-lib": "static-1.14390",
  "integrations-tracking-lib": "static-1.5876",
  "native-integrations-shared-strings": "static-1.8047",
  "sanitize": "static-1.4742",
  "superstore": "static-1.5026",
  "ui-shepherd-react": "static-3.10536",
  "ai-settings-ui-library": "static-1.8281",
  "hub-http-janus": "static-1.873",
  "hubspotter-http": "static-1.4842",
  "immutable-less": "static-1.4919",
  "marketplace-ui-client-types": "static-1.18064",
  "nav-meta": "static-1.30399",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18342",
  "ui-product-approvals-common": "static-1.955",
  "ai-studio-lib": "static-1.12401",
  "hubspot-prosemirror": "static-1.18917",
  "integrations-reconnect-lib": "static-1.444",
  "ui-addon-iframeable": "static-1.9345",
  "ui-addon-integrations-directory-panel": "static-2.8292",
  "ui-product-approvals": "static-1.29060",
  "ui-tool-access": "static-1.10421",
  "inbound-db-properties-service-client": "static-1.4034",
  "property-management-common": "static-1.6351",
  "opentelemetry-fe-types": "static-1.37",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.573",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.412",
  "quartz-auth": "static-1.1088",
  "quartz-test": "static-1.1088",
  "quartz-tracking": "static-1.792",
  "trellis-components": "static-1.2566",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.343",
  "bender-build-tools": "static-1.3411",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22783",
  "ContentUtils": "static-1.69070",
  "customer-data-objects-ui-components": "static-1.13299",
  "sassPrefix": "static-1.163",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.399",
  "batch-promise": "static-1.1811",
  "event-emitter": "static-1.1221",
  "fast-json-patch": "static-1.67",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5734",
  "magpie-types": "static-1.5194",
  "avatar-components": "static-1.2762",
  "breeze-engine-core": "static-1.913",
  "breeze-onboarding-components": "static-1.661",
  "customer-data-filters-ui": "static-1.40822",
  "customer-data-reference-ui-components": "static-1.13447",
  "embedded-academy-lib": "static-1.15443",
  "ExportDialog": "static-6.10647",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41960",
  "reporting-snowflake": "static-1.57312",
  "reporting-ui-components": "static-2.65965",
  "reporting-visualizations": "static-1.60770",
  "trial-components-library": "static-1.14060",
  "trellis-theming": "static-1.1237",
  "ui-addon-teams": "static-1.21875",
  "upgrade-components-lib": "static-1.477",
  "navigation-components": "static-1.18762",
  "breeze-engine-lib": "static-1.1635",
  "simple-logging-lib": "static-1.3319",
  "fail-safe": "static-1.221",
  "app-governance-lib": "static-1.2337",
  "developer-experience-shared-components": "static-1.10772",
  "purchase-motions-components": "static-1.6309",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10121",
  "usage-tracker-anonymous": "static-1.6041",
  "usage-tracker-public": "static-1.7435",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3968",
  "reference-resolvers": "static-1.8450",
  "ui-extensibility-client-types": "static-1.4186",
  "hubspot-apollo-cache": "static-1.606",
  "universal-page-editor-lib": "static-1.3276",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3480",
  "atom": "static-1.5354",
  "merchandise-lib": "static-1.276",
  "salesImages": "static-1.532",
  "ui-addon-draggable": "static-3.5026",
  "content-assistance-lib": "static-1.8159",
  "content-media-capture": "static-1.5372",
  "customer-data-ui-utilities": "static-1.10097",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24417",
  "growth-payments-core": "static-1.26121",
  "knowledge-content-types": "static-1.8635",
  "payment-link-components": "static-1.24114",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20264",
  "ui-addon-emoji-picker": "static-1.10154",
  "ui-business-units-lib": "static-1.9355",
  "video-components-external": "static-1.12100",
  "video-data-lib": "static-1.35758",
  "navigation-messaging": "static-1.8089",
  "collaboration-sidebar": "static-1.58658",
  "react-dnd-compat": "static-1.4885",
  "crm-component-utils": "static-1.39779",
  "crm-properties-common-lib": "static-1.6157",
  "customer-data-properties": "static-1.52496",
  "external-options-client-types": "static-1.4317",
  "framework-data-schema-resolvers": "static-1.7160",
  "property-value-citations": "static-1.3110",
  "reference-resolvers-lite": "static-1.8372",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10564",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5082",
  "content-icons-ui": "static-1.2331",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.988",
  "breeze-artifacts-sdk": "static-1.249",
  "onboarding-journeys-lib": "static-1.857",
  "conversations-skeleton-state": "static-1.7514",
  "crm-message-bus": "static-1.43695",
  "customer-data-filters-ui-msw-helpers": "static-1.23257",
  "events-data-lib": "static-1.510",
  "FormUrlGenerator": "static-2.4995",
  "framework-builder-read-service-client": "static-1.4199",
  "hs-resources": "static-1.459",
  "multi-account-reference-resolvers": "static-1.1268",
  "onboarding-scopes": "static-1.6721",
  "onboarding-tours": "static-1.17072",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14410",
  "academy-common-lib": "static-1.14903",
  "dashboard-lib": "static-1.82714",
  "getting-started-shared-tasks": "static-1.19175",
  "hubspot-prosemirror-plugins": "static-1.18909",
  "share-with-third-party-component-lib": "static-1.8972",
  "ui-asset-management-lib": "static-1.11366",
  "user-context": "static-1.5385",
  "reporting-plugins": "static-1.10700",
  "reporting-reports": "static-1.68372",
  "hubs-service-types": "static-1.1525",
  "purchase-motions-api": "static-1.6312",
  "signup-constants": "static-1.19553",
  "nest": "static-1.503",
  "breeze-engine-chat-components": "static-1.613",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.172",
  "framework-listing-lib": "static-2.29432",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31370",
  "apps-service-types": "static-1.4009",
  "oauth-service-types": "static-1.4507",
  "signup-ui-url-generator": "static-2.8330",
  "onboarding-tours-client": "static-1.5286",
  "one-click-checkout": "static-1.335",
  "platform-infra-nav-components": "static-1.7869",
  "subscription-experience-data-types": "static-1.15219",
  "crm-record-cards-service-types": "static-1.3762",
  "location-customization-utils-lib": "static-1.10039",
  "redux-thunk": "static-2.77",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29255",
  "content-media-composition-data-lib": "static-1.13176",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4693",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.664",
  "ui-addon-opt": "static-4.8632",
  "commerce-tours-lib": "static-1.6569",
  "growth-onboarding-reliability": "static-1.5348",
  "sales-checkout-service-client": "static-1.3798",
  "data-token-picker": "static-1.16845",
  "FileManagerLib": "static-1.40057",
  "content-media-compositions": "static-2.17183",
  "media-bridge-lib": "static-1.19365",
  "chatspot-widget-iframe": "static-1.22774",
  "collaboration-sidebar-common": "static-1.3455",
  "marketing-platform-lib": "static-1.7137",
  "card-properties-lib": "static-1.44949",
  "commerce-subscription-lib": "static-1.37724",
  "crm-actions": "static-1.6620",
  "crm-cards-sdk": "static-1.44473",
  "customer-data-properties-shared-msw-handlers": "static-1.9893",
  "customer-data-tracking": "static-1.7149",
  "calling-global-api": "static-1.65484",
  "calling-internal-common": "static-1.31586",
  "calling-lifecycle-internal": "static-1.66866",
  "calling-lifecycle-messages": "static-1.59160",
  "commerce-products-lib": "static-1.10466",
  "conditional-properties-service-client": "static-1.3989",
  "crm-index-visualization-core": "static-1.4501",
  "crm-links": "static-1.6597",
  "crm-pipelines-api-client-types": "static-1.4325",
  "formula-editor": "static-1.14705",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4403",
  "meetings-icalendar-utils-lib": "static-1.904",
  "multi-currency-client-types": "static-1.3886",
  "object-builder-ui-client": "static-1.49602",
  "pipeline-validation-client-types": "static-1.4160",
  "smart-data-capture-core": "static-1.75",
  "smart-property-lib": "static-1.8228",
  "tiered-pricing": "static-1.1908",
  "topics-actions-lib": "static-1.432",
  "ui-addon-form-validation": "static-1.11251",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.279",
  "framework-data-schema-quick-fetch": "static-1.7065",
  "restore-request-side-panel-lib": "static-1.1610",
  "growth-data-modal": "static-1.5852",
  "growth-onboarding-confetti": "static-1.3331",
  "growth-onboarding-next-action-utils": "static-1.2639",
  "onboarding-tours-utils": "static-1.1138",
  "ui-shepherd-tracker": "static-1.7917",
  "academy-service-client": "static-1.3956",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39916",
  "SafeStorage": "static-1.4671",
  "video-embed": "static-1.36592",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24952",
  "viral-links-lib": "static-1.7344",
  "nested-table": "static-1.502",
  "timezone-utils": "static-2.5512",
  "getting-started-shared-tasks-store": "static-1.18293",
  "campaign-roi-lib": "static-1.10075",
  "campaigns-utils-lib": "static-1.3473",
  "ui-addon-calendars": "static-2.5597",
  "customer-data-views-management": "static-1.25970",
  "framework-data-table": "static-2.12493",
  "nudge-client-utils": "static-1.3107",
  "nudge-custom-ui-functions": "static-1.1448",
  "switchboard-lib": "static-1.483",
  "access-check-ui-lib": "static-1.1527",
  "app-users-service-client": "static-1.5888",
  "app-users-service-types": "static-1.5296",
  "mini-checkout-client": "static-1.27430",
  "onboarding-utils": "static-1.5632",
  "permissions-shared-i18n-strings-fe": "static-1.2119",
  "ui-coaching-tips-shared-config": "static-1.29240",
  "checkout-sdk": "static-3.24273",
  "payment-method-components": "static-1.7117",
  "touchless-buying-components": "static-1.6141",
  "upgrade-catalog-service-types": "static-1.3748",
  "edison-service-client-types": "static-1.660",
  "growth-onboarding-feedback-components": "static-1.6852",
  "audio-components": "static-1.6300",
  "FileManagerImages": "static-1.37568",
  "video-components": "static-1.14102",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92767",
  "customer-data-sidebar": "static-2.46685",
  "enrichment-lib": "static-1.244",
  "ui-addon-draggable-compat": "static-2.4533",
  "universal-record-utils-lib": "static-1.1802",
  "commerce-billing-lib": "static-1.20082",
  "commerce-shared-components-lib": "static-1.19168",
  "commerce-tools-ui-lib": "static-1.10993",
  "crm-fe-perf": "static-1.23170",
  "calling-error-reporting": "static-1.31593",
  "shared-worker-versioning": "static-1.11308",
  "calling-usage-tracker": "static-1.6805",
  "voice-sms-access-library": "static-1.1964",
  "commerce-permissions": "static-1.1046",
  "products-iframe-lib": "static-1.8537",
  "products-ui-components-shared-msw-handlers": "static-1.10948",
  "crm-index-associations-lib": "static-1.6709",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10649",
  "sales-views-client-types": "static-1.4523",
  "bark-lib": "static-1.16781",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.603",
  "policy-lib": "static-1.7065",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10712",
  "onboarding-data-sync-lib": "static-1.2449",
  "growth-onboarding-next-action-components": "static-1.2667",
  "user-context-client": "static-1.4778",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4801",
  "outpost": "static-1.4426",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22115",
  "sales-email-signature-service-client": "static-1.4113",
  "ts-utils-lib": "static-1.426",
  "crm-export-dialog": "static-1.6552",
  "crm-view-components": "static-1.1040",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7595",
  "tasks-actions-lib": "static-1.66",
  "nudge-custom-function-registry": "static-1.2864",
  "nudge-renderer-utils": "static-1.3183",
  "whisper-core-api": "static-1.7274",
  "InboxConnectUtils": "static-4.15503",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46789",
  "hub-http-rxjs": "static-1.837",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4257",
  "company-details-components": "static-1.6471",
  "react-performance-metrics-lib": "static-1.823",
  "pricing-pages-ui-components": "static-1.15621",
  "quote-checkout-service-types": "static-1.3723",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22457",
  "customer-data-email": "static-1.18482",
  "card-payment-highlight-lib": "static-1.37919",
  "card-subscription-highlight-lib": "static-1.40147",
  "commerce-contract-lib": "static-1.13238",
  "invoices-highlight-card-lib": "static-1.55637",
  "orders-highlight-card-lib": "static-1.22138",
  "products-highlight-card-lib": "static-1.18749",
  "quotes-highlight-card-lib": "static-1.72779",
  "crm-source-interpretation-lib": "static-1.5598",
  "data-agent-utils": "static-1.306",
  "crm-object-search-query-utilities": "static-1.10150",
  "utility-belt": "static-1.2802",
  "payments-enrollment-embed-lib": "static-1.23746",
  "stripe-embedded-components": "static-1.7954",
  "customer-data-rte": "static-1.33597",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6226",
  "payments-post-enroll-local-storage-lib": "static-1.5374",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38869",
  "calling-orchestration-schema": "static-1.36741",
  "react-reducer-toolkit": "static-1.16309",
  "meetings-connect-utils-lib": "static-1.7876",
  "hub-http-contrib": "static-1.3307",
  "ui-addon-sales-email": "static-1.5481",
  "access-control-lib": "static-1.10703",
  "EmailComponents": "static-1.55492",
  "EmailData": "static-1.54170",
  "redux-less": "static-2.9745",
  "company-details-service-types": "static-1.4207",
  "segments-query-core": "static-1.1692",
  "pricing-pages-api": "static-1.15486",
  "sequences-lib": "static-1.8494",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.40984",
  "accounting-integrations-ui-components": "static-1.7495",
  "invoices-ui-lib": "static-1.55653",
  "commerce-products-api": "static-1.2656",
  "invoices-iframe-lib": "static-1.57711",
  "quotes-modal-lib": "static-1.103457",
  "quotes-ui-lib": "static-1.81500",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28859",
  "ContentComponents": "static-2.72026",
  "ContentData": "static-1.69145",
  "marketing-contacts-lib": "static-1.10957",
  "marketing-email-service-types": "static-1.2077",
  "messaging-editing-lib": "static-1.47078",
  "messaging-usage-based-billing-components-lib": "static-1.1940",
  "automation-ui-source-apps": "static-1.19626",
  "automation-ui-types": "static-1.20544",
  "messaging-types-lib": "static-1.46815",
  "onboarding-settings-client": "static-1.4776",
  "sequences-client-types-lib": "static-1.8351",
  "commerce-tax-lib": "static-1.806",
  "price-books-api": "static-1.1680",
  "price-books-components": "static-1.1738",
  "property-description-translator": "static-1.4109",
  "ramp-editor": "static-1.842",
  "commerce-analytics-service-client": "static-1.3786",
  "totals-ui-components": "static-1.24243",
  "SalesContentIndexUI": "static-3.9591",
  "advanced-menus-core": "static-1.15536",
  "advanced-menus-lib": "static-1.12414",
  "automation-ui-ubb": "static-1.6460",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7606",
  "data-token-views": "static-1.16826",
  "forms-utils-lib": "static-1.13053",
  "payments-embed-points-lib": "static-1.13542",
  "react-tinymce": "static-1.55922",
  "simple-menus-core": "static-1.15535",
  "simple-menus-lib": "static-1.17052",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55048",
  "tinymce-data": "static-1.41133",
  "tinymce-plugins": "static-1.58162",
  "tinymce-themes": "static-1.57018",
  "ui-brand-identity-lib": "static-1.16349",
  "ui-memberships-settings-lib": "static-1.34787",
  "videoconference-integration-components": "static-1.7212",
  "marketing-contacts-client": "static-1.7778",
  "mc-hard-limits-client-types": "static-1.172",
  "automation-applications-service-types": "static-1.3651",
  "automation-platform-service-types": "static-1.2662",
  "ContentEditorUI": "static-2.77847",
  "short-messages-app-service-client": "static-1.4182",
  "web-interactives-components": "static-1.14207",
  "web-interactives-data": "static-1.14208",
  "messaging-shared-utils-lib": "static-1.1389",
  "messaging-user-info-utils-lib": "static-1.1559",
  "email-portal-health-service-types": "static-1.1247",
  "line-items-api": "static-1.1057",
  "commerce-totals-service-types": "static-1.4008",
  "FireAlarmUi": "static-1.4696",
  "sales-templates-service-types-lib": "static-1.4362",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22480",
  "automation-ui-usage-tracking": "static-1.21943",
  "data-studio-ubb": "static-1.3454",
  "interframe": "static-3.5024",
  "layout-dnd-components": "static-1.12921",
  "layout-dnd-utils": "static-1.11896",
  "NamespacedHubStyle": "static-2.9240",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27601",
  "content-management-data-lib": "static-1.5909",
  "copilot-plugins": "static-1.11767",
  "cta-picker": "static-1.37033",
  "customer-agent-discovery-components-lib": "static-1.3837",
  "editor-components": "static-1.13609",
  "editor-iframe-lib": "static-1.8757",
  "error-messaging-js": "static-1.5463",
  "FormsCommonComponents": "static-1.86506",
  "layout-data-lib": "static-1.10221",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.69",
  "redux-request-state": "static-1.10917",
  "SharedLegalStrings": "static-1.2016",
  "smart-content-core": "static-1.43119",
  "smart-content-lib": "static-1.43772",
  "social-composer-lib": "static-1.60172",
  "structured-content-lib": "static-1.25864",
  "theme-previewer-lib": "static-1.53892",
  "tinymce-copilot": "static-1.17116",
  "xray-recommendation-lib": "static-1.8227",
  "automation-ui-routing": "static-1.21901",
  "sql-reporting-client-types": "static-1.5865",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42739",
  "reporting-enablement": "static-1.23771",
  "forms-ai-lib": "static-1.4721",
  "codemirror-dlb": "static-1.59406",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6707",
  "report-customization-components": "static-1.13855",
  "data-quality-ui-library": "static-1.13733",
  "reporting-filters": "static-1.952",
  "reporting-insights-lib": "static-1.2512"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13170",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.679",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9926",
  "foundations-components": "/foundations-components/static-1.8437",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1462",
  "foundations-theming": "/foundations-theming/static-1.4738",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8298",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10566",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11756",
  "I18n": "/I18n/static-7.1667",
  "jasmine-runner": "/jasmine-runner/static-1.6721",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.587",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13233",
  "quartz": "/quartz/static-1.7413",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3122",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10628",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12790",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7588",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11414",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9806",
  "unified-auth": "/unified-auth/static-1.856",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1138",
  "usage-tracker": "/usage-tracker/static-1.7624",
  "usage-tracker-core": "/usage-tracker-core/static-1.7474",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8370",
  "hub-http": "/hub-http/static-1.6481",
  "integrations-lib": "/integrations-lib/static-1.16975",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20657",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.643",
  "property-management-iframe": "/property-management-iframe/static-1.14063",
  "quartz-config": "/quartz-config/static-1.1191",
  "quartz-core": "/quartz-core/static-1.6632",
  "quartz-routing": "/quartz-routing/static-1.843",
  "quick-fetch": "/quick-fetch/static-1.4109",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4933",
  "ts-schema": "/ts-schema/static-1.4271",
  "ui-universal-auth": "/ui-universal-auth/static-1.9342",
  "UIComponents": "/UIComponents/static-3.8702",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3596",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3690",
  "quartz-webpack": "/quartz-webpack/static-1.3637",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.491",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9650",
  "codemirror": "/codemirror/static-5.99",
  "foundations-assets": "/foundations-assets/static-1.5151",
  "pulse": "/pulse/static-1.896",
  "react-codemirror": "/react-codemirror/static-1.10907",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.542",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4706",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2454",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9695",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.66",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5534",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.499",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2547",
  "ui-fonts": "/ui-fonts/static-1.1018",
  "ui-images": "/ui-images/static-2.1238",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3221",
  "foundations-theming-base": "/foundations-theming-base/static-1.3723",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.793",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3409",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4582",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8970",
  "ai-rendering-library": "/ai-rendering-library/static-1.11045",
  "chirp-fetch": "/chirp-fetch/static-1.2162",
  "connections-embed-lib": "/connections-embed-lib/static-1.1471",
  "copilot-toolkit": "/copilot-toolkit/static-1.11795",
  "feedback-loader": "/feedback-loader/static-1.29767",
  "laboratory-lib": "/laboratory-lib/static-3.7420",
  "marketplace-embed": "/marketplace-embed/static-1.22846",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10552",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20612",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14827",
  "sanitize-text": "/sanitize-text/static-1.8421",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6038",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5310",
  "wootric-nps": "/wootric-nps/static-1.7177",
  "quartz-head": "/quartz-head/static-1.1078",
  "web-vitals": "/web-vitals/static-1.12",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4924",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4419",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2661",
  "reporting-data": "/reporting-data/static-1.68695",
  "cssUtils": "/cssUtils/static-1.888",
  "flux-actions": "/flux-actions/static-1.364",
  "HubStyle": "/HubStyle/static-2.12063",
  "PatternValidationJS": "/PatternValidationJS/static-1.3163",
  "react-colorpicker": "/react-colorpicker/static-2.10476",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10638",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7614",
  "icons": "/icons/static-2.677",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19189",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4776",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5920",
  "quartz-i18n": "/quartz-i18n/static-1.1088",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.406",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1195",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.975",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.74",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.420",
  "slack-ui-library": "/slack-ui-library/static-1.10666",
  "fsm": "/fsm/static-1.4013",
  "customer-data-objects": "/customer-data-objects/static-1.7955",
  "property-translator": "/property-translator/static-1.5666",
  "hs-locale-management": "/hs-locale-management/static-1.270",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8191",
  "hs-promise-utils": "/hs-promise-utils/static-1.5865",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5147",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14390",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5876",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8047",
  "sanitize": "/sanitize/static-1.4742",
  "superstore": "/superstore/static-1.5026",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10536",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8281",
  "hub-http-janus": "/hub-http-janus/static-1.873",
  "hubspotter-http": "/hubspotter-http/static-1.4842",
  "immutable-less": "/immutable-less/static-1.4919",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18064",
  "nav-meta": "/nav-meta/static-1.30399",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18342",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.955",
  "ai-studio-lib": "/ai-studio-lib/static-1.12401",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18917",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.444",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9345",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8292",
  "ui-product-approvals": "/ui-product-approvals/static-1.29060",
  "ui-tool-access": "/ui-tool-access/static-1.10421",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4034",
  "property-management-common": "/property-management-common/static-1.6351",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.37",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.573",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.412",
  "quartz-auth": "/quartz-auth/static-1.1088",
  "quartz-test": "/quartz-test/static-1.1088",
  "quartz-tracking": "/quartz-tracking/static-1.792",
  "trellis-components": "/trellis-components/static-1.2566",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.343",
  "bender-build-tools": "/bender-build-tools/static-1.3411",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22783",
  "ContentUtils": "/ContentUtils/static-1.69070",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13299",
  "sassPrefix": "/sassPrefix/static-1.163",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.399",
  "batch-promise": "/batch-promise/static-1.1811",
  "event-emitter": "/event-emitter/static-1.1221",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5734",
  "magpie-types": "/magpie-types/static-1.5194",
  "avatar-components": "/avatar-components/static-1.2762",
  "breeze-engine-core": "/breeze-engine-core/static-1.913",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.661",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40822",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13447",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15443",
  "ExportDialog": "/ExportDialog/static-6.10647",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41960",
  "reporting-snowflake": "/reporting-snowflake/static-1.57312",
  "reporting-ui-components": "/reporting-ui-components/static-2.65965",
  "reporting-visualizations": "/reporting-visualizations/static-1.60770",
  "trial-components-library": "/trial-components-library/static-1.14060",
  "trellis-theming": "/trellis-theming/static-1.1237",
  "ui-addon-teams": "/ui-addon-teams/static-1.21875",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.477",
  "navigation-components": "/navigation-components/static-1.18762",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1635",
  "simple-logging-lib": "/simple-logging-lib/static-1.3319",
  "fail-safe": "/fail-safe/static-1.221",
  "app-governance-lib": "/app-governance-lib/static-1.2337",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10772",
  "purchase-motions-components": "/purchase-motions-components/static-1.6309",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10121",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6041",
  "usage-tracker-public": "/usage-tracker-public/static-1.7435",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3968",
  "reference-resolvers": "/reference-resolvers/static-1.8450",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4186",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.606",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3276",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3480",
  "atom": "/atom/static-1.5354",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "salesImages": "/salesImages/static-1.532",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5026",
  "content-assistance-lib": "/content-assistance-lib/static-1.8159",
  "content-media-capture": "/content-media-capture/static-1.5372",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10097",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24417",
  "growth-payments-core": "/growth-payments-core/static-1.26121",
  "knowledge-content-types": "/knowledge-content-types/static-1.8635",
  "payment-link-components": "/payment-link-components/static-1.24114",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20264",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10154",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9355",
  "video-components-external": "/video-components-external/static-1.12100",
  "video-data-lib": "/video-data-lib/static-1.35758",
  "navigation-messaging": "/navigation-messaging/static-1.8089",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58658",
  "react-dnd-compat": "/react-dnd-compat/static-1.4885",
  "crm-component-utils": "/crm-component-utils/static-1.39779",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6157",
  "customer-data-properties": "/customer-data-properties/static-1.52496",
  "external-options-client-types": "/external-options-client-types/static-1.4317",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7160",
  "property-value-citations": "/property-value-citations/static-1.3110",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8372",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10564",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5082",
  "content-icons-ui": "/content-icons-ui/static-1.2331",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.988",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.249",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.857",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7514",
  "crm-message-bus": "/crm-message-bus/static-1.43695",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23257",
  "events-data-lib": "/events-data-lib/static-1.510",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4995",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4199",
  "hs-resources": "/hs-resources/static-1.459",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1268",
  "onboarding-scopes": "/onboarding-scopes/static-1.6721",
  "onboarding-tours": "/onboarding-tours/static-1.17072",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14410",
  "academy-common-lib": "/academy-common-lib/static-1.14903",
  "dashboard-lib": "/dashboard-lib/static-1.82714",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19175",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18909",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8972",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11366",
  "user-context": "/user-context/static-1.5385",
  "reporting-plugins": "/reporting-plugins/static-1.10700",
  "reporting-reports": "/reporting-reports/static-1.68372",
  "hubs-service-types": "/hubs-service-types/static-1.1525",
  "purchase-motions-api": "/purchase-motions-api/static-1.6312",
  "signup-constants": "/signup-constants/static-1.19553",
  "nest": "/nest/static-1.503",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.613",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.172",
  "framework-listing-lib": "/framework-listing-lib/static-2.29432",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31370",
  "apps-service-types": "/apps-service-types/static-1.4009",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8330",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5286",
  "one-click-checkout": "/one-click-checkout/static-1.335",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7869",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15219",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3762",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10039",
  "redux-thunk": "/redux-thunk/static-2.77",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29255",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13176",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4693",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.664",
  "ui-addon-opt": "/ui-addon-opt/static-4.8632",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6569",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5348",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3798",
  "data-token-picker": "/data-token-picker/static-1.16845",
  "FileManagerLib": "/FileManagerLib/static-1.40057",
  "content-media-compositions": "/content-media-compositions/static-2.17183",
  "media-bridge-lib": "/media-bridge-lib/static-1.19365",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22774",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3455",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7137",
  "card-properties-lib": "/card-properties-lib/static-1.44949",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37724",
  "crm-actions": "/crm-actions/static-1.6620",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44473",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9893",
  "customer-data-tracking": "/customer-data-tracking/static-1.7149",
  "calling-global-api": "/calling-global-api/static-1.65484",
  "calling-internal-common": "/calling-internal-common/static-1.31586",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66866",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59160",
  "commerce-products-lib": "/commerce-products-lib/static-1.10466",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3989",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4501",
  "crm-links": "/crm-links/static-1.6597",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4325",
  "formula-editor": "/formula-editor/static-1.14705",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4403",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.904",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3886",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49602",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4160",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.75",
  "smart-property-lib": "/smart-property-lib/static-1.8228",
  "tiered-pricing": "/tiered-pricing/static-1.1908",
  "topics-actions-lib": "/topics-actions-lib/static-1.432",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11251",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.279",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7065",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1610",
  "growth-data-modal": "/growth-data-modal/static-1.5852",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3331",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2639",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1138",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7917",
  "academy-service-client": "/academy-service-client/static-1.3956",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39916",
  "SafeStorage": "/SafeStorage/static-1.4671",
  "video-embed": "/video-embed/static-1.36592",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24952",
  "viral-links-lib": "/viral-links-lib/static-1.7344",
  "nested-table": "/nested-table/static-1.502",
  "timezone-utils": "/timezone-utils/static-2.5512",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18293",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10075",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3473",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5597",
  "customer-data-views-management": "/customer-data-views-management/static-1.25970",
  "framework-data-table": "/framework-data-table/static-2.12493",
  "nudge-client-utils": "/nudge-client-utils/static-1.3107",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1448",
  "switchboard-lib": "/switchboard-lib/static-1.483",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1527",
  "app-users-service-client": "/app-users-service-client/static-1.5888",
  "app-users-service-types": "/app-users-service-types/static-1.5296",
  "mini-checkout-client": "/mini-checkout-client/static-1.27430",
  "onboarding-utils": "/onboarding-utils/static-1.5632",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2119",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29240",
  "checkout-sdk": "/checkout-sdk/static-3.24273",
  "payment-method-components": "/payment-method-components/static-1.7117",
  "touchless-buying-components": "/touchless-buying-components/static-1.6141",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3748",
  "edison-service-client-types": "/edison-service-client-types/static-1.660",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6852",
  "audio-components": "/audio-components/static-1.6300",
  "FileManagerImages": "/FileManagerImages/static-1.37568",
  "video-components": "/video-components/static-1.14102",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92767",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46685",
  "enrichment-lib": "/enrichment-lib/static-1.244",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4533",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1802",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20082",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19168",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10993",
  "crm-fe-perf": "/crm-fe-perf/static-1.23170",
  "calling-error-reporting": "/calling-error-reporting/static-1.31593",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11308",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6805",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1964",
  "commerce-permissions": "/commerce-permissions/static-1.1046",
  "products-iframe-lib": "/products-iframe-lib/static-1.8537",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10948",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6709",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10649",
  "sales-views-client-types": "/sales-views-client-types/static-1.4523",
  "bark-lib": "/bark-lib/static-1.16781",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.603",
  "policy-lib": "/policy-lib/static-1.7065",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10712",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2449",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2667",
  "user-context-client": "/user-context-client/static-1.4778",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4801",
  "outpost": "/outpost/static-1.4426",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22115",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4113",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6552",
  "crm-view-components": "/crm-view-components/static-1.1040",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7595",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.66",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2864",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3183",
  "whisper-core-api": "/whisper-core-api/static-1.7274",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15503",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46789",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.837",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4257",
  "company-details-components": "/company-details-components/static-1.6471",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.823",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15621",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3723",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22457",
  "customer-data-email": "/customer-data-email/static-1.18482",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37919",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40147",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13238",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55637",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22138",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18749",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72779",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5598",
  "data-agent-utils": "/data-agent-utils/static-1.306",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10150",
  "utility-belt": "/utility-belt/static-1.2802",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23746",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7954",
  "customer-data-rte": "/customer-data-rte/static-1.33597",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6226",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5374",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38869",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36741",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16309",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7876",
  "hub-http-contrib": "/hub-http-contrib/static-1.3307",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5481",
  "access-control-lib": "/access-control-lib/static-1.10703",
  "EmailComponents": "/EmailComponents/static-1.55492",
  "EmailData": "/EmailData/static-1.54170",
  "redux-less": "/redux-less/static-2.9745",
  "company-details-service-types": "/company-details-service-types/static-1.4207",
  "segments-query-core": "/segments-query-core/static-1.1692",
  "pricing-pages-api": "/pricing-pages-api/static-1.15486",
  "sequences-lib": "/sequences-lib/static-1.8494",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.40984",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7495",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55653",
  "commerce-products-api": "/commerce-products-api/static-1.2656",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57711",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103457",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81500",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28859",
  "ContentComponents": "/ContentComponents/static-2.72026",
  "ContentData": "/ContentData/static-1.69145",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10957",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2077",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47078",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1940",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19626",
  "automation-ui-types": "/automation-ui-types/static-1.20544",
  "messaging-types-lib": "/messaging-types-lib/static-1.46815",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4776",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8351",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.806",
  "price-books-api": "/price-books-api/static-1.1680",
  "price-books-components": "/price-books-components/static-1.1738",
  "property-description-translator": "/property-description-translator/static-1.4109",
  "ramp-editor": "/ramp-editor/static-1.842",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3786",
  "totals-ui-components": "/totals-ui-components/static-1.24243",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9591",
  "advanced-menus-core": "/advanced-menus-core/static-1.15536",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12414",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6460",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7606",
  "data-token-views": "/data-token-views/static-1.16826",
  "forms-utils-lib": "/forms-utils-lib/static-1.13053",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13542",
  "react-tinymce": "/react-tinymce/static-1.55922",
  "simple-menus-core": "/simple-menus-core/static-1.15535",
  "simple-menus-lib": "/simple-menus-lib/static-1.17052",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55048",
  "tinymce-data": "/tinymce-data/static-1.41133",
  "tinymce-plugins": "/tinymce-plugins/static-1.58162",
  "tinymce-themes": "/tinymce-themes/static-1.57018",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16349",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34787",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7212",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7778",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.172",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3651",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2662",
  "ContentEditorUI": "/ContentEditorUI/static-2.77847",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4182",
  "web-interactives-components": "/web-interactives-components/static-1.14207",
  "web-interactives-data": "/web-interactives-data/static-1.14208",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1389",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1559",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1247",
  "line-items-api": "/line-items-api/static-1.1057",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4008",
  "FireAlarmUi": "/FireAlarmUi/static-1.4696",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4362",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22480",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21943",
  "data-studio-ubb": "/data-studio-ubb/static-1.3454",
  "interframe": "/interframe/static-3.5024",
  "layout-dnd-components": "/layout-dnd-components/static-1.12921",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11896",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9240",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27601",
  "content-management-data-lib": "/content-management-data-lib/static-1.5909",
  "copilot-plugins": "/copilot-plugins/static-1.11767",
  "cta-picker": "/cta-picker/static-1.37033",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3837",
  "editor-components": "/editor-components/static-1.13609",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8757",
  "error-messaging-js": "/error-messaging-js/static-1.5463",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86506",
  "layout-data-lib": "/layout-data-lib/static-1.10221",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.69",
  "redux-request-state": "/redux-request-state/static-1.10917",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2016",
  "smart-content-core": "/smart-content-core/static-1.43119",
  "smart-content-lib": "/smart-content-lib/static-1.43772",
  "social-composer-lib": "/social-composer-lib/static-1.60172",
  "structured-content-lib": "/structured-content-lib/static-1.25864",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53892",
  "tinymce-copilot": "/tinymce-copilot/static-1.17116",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8227",
  "automation-ui-routing": "/automation-ui-routing/static-1.21901",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5865",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42739",
  "reporting-enablement": "/reporting-enablement/static-1.23771",
  "forms-ai-lib": "/forms-ai-lib/static-1.4721",
  "codemirror-dlb": "/codemirror-dlb/static-1.59406",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6707",
  "report-customization-components": "/report-customization-components/static-1.13855",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13733",
  "reporting-filters": "/reporting-filters/static-1.952",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2512"
}
};
